import { StatementsContext } from '@views/contexts'
import { useContext } from 'react'

export const useStatements = () => useContext(StatementsContext)
